<template>
  <div class="outer">
    <div class="left">
      <tree-select
        v-if="tree"
        :treeValue="treeValue"
        @treeValue="getTree"
        @treeAll="getAll"
        style="width:30rem;"
        :alwaysOpen="true"
        :option="treeOption"
      ></tree-select>
    </div>
    <div class="right">
      <el-button type="primary" plain @click="addOrg">新增组织</el-button>
      <el-popconfirm title="你确定要删除当前组织吗？" @onConfirm="deleteOrg">
        <el-button style="margin:0 10px" type="danger" slot="reference"
          >删除当前组织</el-button
        >
      </el-popconfirm>
      <!-- <el-button style="margin:0 10px" type="danger" slot="reference"  @click="deleteOrg">删除当前组织</el-button> -->
      <div style="width:30rem;marginTop:2rem" v-show="details">
        <el-form v-model="detailsList" label-width="100px">
          <el-form-item label="名称">
            <el-input v-model="detailsList.name"></el-input>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model="detailsList.code"></el-input>
          </el-form-item>
          <el-form-item label="简称">
            <el-input v-model="detailsList.shortName"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number
              v-model="detailsList.sort"
              controls-position="right"
              :min="0"
              :max="20"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="detailsList.type" placeholder="请选择">
              <el-option
                v-for="(item, i) of typeList"
                :key="i"
                :label="item"
                :value="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用模块" v-show="detailsList.type == 1">
            <el-checkbox-group @change="test" v-model="detailsList.appIdList">
              <el-checkbox-button
                v-for="(elem, i) of appList"
                :label="elem.id"
                :key="i"
                >{{ elem.name }}</el-checkbox-button
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="应用默认模块" v-show="detailsList.type == 1">
            <el-radio-group v-model="detailsList.defaultAppid">
              <el-radio-button
                v-for="(elem, i) of appList"
                :label="elem.id"
                :key="i"
                >{{ elem.name }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="到期时间">
            <el-date-picker
              v-model="detailsList.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="账号临期提醒">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="300"
              show-word-limit
              placeholder="尊敬的XX用户您好！您的账号将于7天后到期，请及时联系图书馆（电话：12345678）续期。"
              v-model="detailsList.adventReminder"
            >
            </el-input>
            <p class="tips">
              模板：尊敬的XX用户您好！您的账号将于7天后到期，请及时联系图书馆（电话：12345678）续期。
            </p>
          </el-form-item>
          <el-form-item label="账号到期提醒">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="300"
              show-word-limit
              placeholder="尊敬的XX用户您好！您的账号已到期，请联系图书馆（电话：12345678）续期。"
              v-model="detailsList.expirationReminder"
            >
            </el-input>
            <p class="tips">
              模板：尊敬的XX用户您好！您的账号已到期，请联系图书馆（电话：12345678）续期。
            </p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="sub">确认提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div style="clear:both"></div> -->
    <el-dialog title="新增组织机构" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="140px">
        <el-form-item label="组织结构名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="编号">
          <el-input v-model="form.code"></el-input>
        </el-form-item>-->
        <el-form-item label="简称">
          <el-input v-model="form.shortName"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="form.sort"
            controls-position="right"
            :min="0"
            :max="20"
          ></el-input-number>
          <!-- <el-input v-model="form.sort"></el-input> -->
        </el-form-item>
        <el-form-item label="type">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="(item, i) of typeList"
              :key="i"
              :label="item"
              :value="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级组织架构">
          <tree-select
            :treeValue="treeValue1"
            @treeValueLevel="getlevel"
            @treeValueParentId="getparentId"
            style="width:200px"
            v-if="tree1"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
        <el-form-item label="APP应用模块" v-show="form.type == 1">
          <el-checkbox-group v-model="form.appIdList">
            <el-checkbox-button
              v-for="(elem, i) of appList"
              :label="elem.id"
              :key="i"
              >{{ elem.name }}</el-checkbox-button
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="APP应用默认模块" v-show="form.type == 1">
          <el-radio-group v-model="form.defaultAppid">
            <el-radio-button
              v-for="(elem, i) of appList"
              :label="elem.id"
              :key="i"
              >{{ elem.name }}</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
export default {
  components: {
    treeSelect,
  },
  mounted() {
    this.load();
    this.getAppIds();
  },
  data() {
    return {
      appList: [],
      treeValue: null,
      treeValue1: null,
      tree: false,
      tree1: false,
      treeOption: [],
      details: false, //右侧详情
      detailsList: {
        name: "",
        code: "",
        shortName: "",
        parentId: "",
        id: "",
        sort: "",
        type: "",
        appIdList: [], //默认值
        defaultAppid: "",
        expirationReminder: "",
        adventReminder: "",
        endDate: "",
      },
      Id: "",
      dialogVisible: false,
      typeList: ["其他", "机构(医院)", "科室"],
      form: {
        name: "", //用户名
        code: "", //编号
        shortName: "", //真实姓名
        parentId: "", //上级架构的id
        level: "",
        id: "",
        sort: "",
        type: "",
        appIdList: [],
        defaultAppid: "",
      },
    };
  },
  methods: {
    getAll(x) {
      // console.log(x)
      this.detailsList.name = x.name;
      this.detailsList.code = x.code;
      this.detailsList.shortName = x.shortName;
      this.detailsList.parentId = x.parentId;
      this.detailsList.id = x.id;
      this.detailsList.sort = x.sort;
      this.detailsList.type = x.type;
      this.detailsList.defaultAppid = x.defaultAppid;
      // this.detailsList.appIdList = x.appIdList ? x.appIdList : [];

      const appList = this.appList.map((item) => item.id);
      // console.log(x.appIdList, "appIdList");
      // console.log(appList, "appList");
      if (x.appIdList && x.appIdList.length) {
        const result = x.appIdList.filter((item) => appList.includes(item));
        this.detailsList.appIdList = result;

        console.log(result, "idList");
      } else {
        this.detailsList.appIdList = [];
      }

      this.detailsList.expirationReminder = x.expirationReminder;
      this.detailsList.adventReminder = x.adventReminder;
      this.detailsList.endDate = x.endDate;
      // console.log(Array.isArray(this.detailsList.appIdList));
    },
    //获取医院id
    getTree(x) {
      // console.log(x);
      this.details = true;
      this.Id = x;
    },
    //递归查找组织并加载详情
    loadOrgDetails(orgId, treeData) {
      const findOrg = (nodes) => {
        for (let node of nodes) {
          if (node.id === orgId) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findOrg(node.children);
            if (found) return found;
          }
        }
        return null;
      };

      const orgData = findOrg(treeData);
      if (orgData) {
        this.details = true;
        this.getAll(orgData);
      }
    },
    //获取level
    getlevel(x) {
      this.form.level = x;
    },
    //获取父级id
    getparentId(x) {
      this.form.parentId = x;
    },
    //新增弹出框属性重置
    addOrg() {
      this.tree1 = false;
      this.treeValue1 = this.Id ? Number(this.Id) : 1;
      // console.log(this.detailsList.id);
      this.form = {
        name: "", //用户名
        // code: "", //编号
        shortName: "", //真实姓名
        parentId: this.treeValue1, //上级架构的id
        level: "",
        id: "",
        sort: "",
        type: "",
        appIdList: [],
      };
      let timer = setTimeout(() => {
        this.dialogVisible = true;
        this.tree1 = true;
        clearTimeout(timer);
      }, 10);
    },
    //新增组织机构
    add() {
      // console.log(this.form);
      this.$api.addUpdataOrg(this.form).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
          this.dialogVisible = false;
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    //删除
    deleteOrg() {
      this.$api.orgDelete(this.detailsList.id).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
          this.details = false;
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    load() {
      this.tree = false;
      this.$api.structureList().then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.$nextTick(() => {
            this.tree = true;
            this.treeOption = res.data.data;
            // 检查路由参数中是否有orgId
            if (this.$route.query.orgId) {
              const orgId = Number(this.$route.query.orgId);
              this.treeValue = orgId;
              this.Id = orgId;
              // 查找并加载组织详情
              this.loadOrgDetails(orgId, res.data.data);
            }
          });
        }
      });
    },
    //提交修改
    sub() {
      this.$api.addUpdataOrg(this.detailsList).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    test() {
      console.log(this.detailsList);
    },
    //获取app列表
    getAppIds() {
      this.$api.AppRunList({}).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.appList = res.data.data.records.map((elem) => {
            return {
              id: elem.id,
              name: elem.name,
            };
          });
          console.log(this.appList, "applist");
        }
      });
    },
  },
};
</script>

<style scoped>
.outer {
  width: 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
}
.left {
  width: 30rem;
}
.right {
  width: 30rem;
  margin-left: 2rem;
}

.tips {
  font-size: 12px;
  color: #c4c4c4;
  line-height: 25px;
}
</style>
